export default __webpack_public_path__ + "static/media/20.47eea44e.jpg";